import React, { memo } from 'react'
import styled from 'styled-components'

import Section from 'components/atoms/layout/Section'

const StyledSection = styled(Section)`
  overflow: hidden;
  position: relative;
  text-align: center;
  background-color: ${props => props.theme.colors.darkBg};
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='69' height='6' x='0px' y='0px' viewBox='0 0 92 8' style='enable-background:new 0 0 92 8;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bopacity:0.1;fill:none;stroke:%23F2F2F2;stroke-width:0.75;stroke-miterlimit:10;%7D%0A%3C/style%3E%3Cpath class='st0' d='M0,0c23,0,23-10,46-10S69,0,92,0'/%3E%3Cpath class='st0' d='M0,8C23,8,23-2,46-2S69,8,92,8'/%3E%3Cpath class='st0' d='M0,16C23,16,23,6,46,6s23,10,46,10'/%3E%3C/svg%3E%0A");
`

const SectionWaveBg = props => {
  return <StyledSection color="white" {...props} />
}

export default memo(SectionWaveBg)
